module.exports = __webpack_public_path__ + "static/home-hero-10th-f3c2374430151d0aa7287e0fcc7584c7.png";